import axiosInstance from "./AxiosInstance";

// ============================================================
// LotsServices — wrappers Axios para o módulo Lotes (2026-05).
// API: api/Controllers/LotsController.js + api/Controllers/SupplierController.js
// ============================================================

// ---- Lotes (CRUD + status) ----
export function getLotsList(data) {
  return axiosInstance.post(`/lot/list`, data);
}
export function getLotsActiveList(data) {
  return axiosInstance.post(`/lot/active-list`, data);
}
export function getLotDetails(data) {
  return axiosInstance.post(`/lot/details`, data);
}
export function createLot(data) {
  return axiosInstance.post(`/lot/create`, data);
}
export function updateLot(data) {
  return axiosInstance.post(`/lot/update`, data);
}
export function deleteLot(data) {
  return axiosInstance.post(`/lot/delete`, data);
}
export function updateLotStorageStatus(data) {
  return axiosInstance.post(`/lot/storage-status`, data);
}

// ---- Lot ↔ Suppliers ----
export function lotSupplierAdd(data) {
  return axiosInstance.post(`/lot/supplier/add`, data);
}
export function lotSupplierRemove(data) {
  return axiosInstance.post(`/lot/supplier/remove`, data);
}
export function lotSupplierSetDefault(data) {
  return axiosInstance.post(`/lot/supplier/set-default`, data);
}

// ---- Lot ↔ Vehicles (real e lite) ----
export function lotVehicleAdd(data) {
  return axiosInstance.post(`/lot/vehicle/add`, data);
}
export function lotVehicleUpdate(data) {
  return axiosInstance.post(`/lot/vehicle/update`, data);
}
export function lotVehicleRemove(data) {
  return axiosInstance.post(`/lot/vehicle/remove`, data);
}
export function lotVehicleSetDefault(data) {
  return axiosInstance.post(`/lot/vehicle/set-default`, data);
}

// ---- Lot ↔ Warehouses ----
export function lotWarehouseAdd(data) {
  return axiosInstance.post(`/lot/warehouse/add`, data);
}
export function lotWarehouseRemove(data) {
  return axiosInstance.post(`/lot/warehouse/remove`, data);
}

// ---- Lot Parts (read-only listing) ----
export function getLotPartsList(data) {
  return axiosInstance.post(`/lot/parts/list`, data);
}

// ---- Lot Images (multipart para add) ----
export function lotImagesAdd(formData) {
  return axiosInstance.post(`/lot/images/add`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
export function lotImagesSort(data) {
  return axiosInstance.post(`/lot/images/sort`, data);
}
export function lotImagesDelete(data) {
  return axiosInstance.post(`/lot/images/delete`, data);
}

// ---- Lot Videos (multipart para add) ----
export function lotVideosAdd(formData) {
  return axiosInstance.post(`/lot/videos/add`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
export function lotVideosSort(data) {
  return axiosInstance.post(`/lot/videos/sort`, data);
}
export function lotVideosDelete(data) {
  return axiosInstance.post(`/lot/videos/delete`, data);
}

// ---- Trocar lote de uma peça existente ----
export function updatePartLot(data) {
  return axiosInstance.post(`/update-part-lot`, data);
}
